import { Injectable } from '@angular/core';
import { CmsContainer } from '@domgen/dgx-fe-cms';
import { CmsContactUsPage, CmsContentPage } from '@support/util-models';
import { combineLatest, Observable } from 'rxjs';

export interface ViewModel {
  cmsData: CmsContentPage;
}

@Injectable()
export class ContentComponentService {
  readonly vm$: Observable<ViewModel> = combineLatest({
    cmsData: this.cmsContainer.content$,
  });

  constructor(private readonly cmsContainer: CmsContainer<CmsContactUsPage>) {}
}
